export enum YesOrNo {
  Yes = 'yes',
  No = 'no',
}

export const YES_OR_NO_TRANSLATIONS = {
  [YesOrNo.Yes]: 'Ja',
  [YesOrNo.No]: 'Nein',
};
